module.exports = __webpack_public_path__ + "img/code.020287cb.png";